<app-navbar></app-navbar>
<div class="container-fluid">

  <!-- Cabeçalho + Filtros -->
  <div class="card shadow-sm filtros-modernas border-0 mb-4">
    <div class="card-header d-flex align-items-center rounded-top">
      <i class="fas fa-chart-pie fs-5 me-2 text-white"></i>
      <h2 class="fw-bold">Relatório Geral de Vistorias</h2>
    </div>
    <div class="card-body">
      <div class="row mt-3" *ngIf="!erro">
        <div class="top-controls compact-controls d-flex flex-wrap align-items-center justify-content-between">
          <div class="d-flex gap-2">
            <button class="btn btn-info btn-sm" type="button" (click)="showFiltros = !showFiltros">
              <i class="fas fa-filter me-1"></i> Filtrar
            </button>
            <button class="btn btn-success btn-sm" type="button" (click)="exportarParaExcel()"
              [disabled]="!dados"
              title="Exportar para Excel">
              <i class="fas fa-file-excel me-1"></i> Exportar Excel
            </button>
          </div>

          <div class="d-flex align-items-center gap-2 me-3 flex-wrap">
            <div class="d-flex gap-2">
              <button type="button" class="btn btn-sm" [class.btn-primary]="modoTotal" [class.btn-outline-primary]="!modoTotal" (click)="setModoTotal(true)">
                <i class="fas fa-infinity me-1"></i> Total
              </button>
              <button type="button" class="btn btn-sm" [class.btn-primary]="!modoTotal" [class.btn-outline-primary]="modoTotal" (click)="setModoTotal(false)">
                <i class="fas fa-calendar-alt me-1"></i> Personalizado
              </button>
            </div>
            <ng-container *ngIf="!modoTotal">
              <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataInicio" />
              <span>até</span>
              <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataFim" />
            </ng-container>
            <span class="badge-total-sutil ms-2" *ngIf="dados">
              <i class="fas fa-list me-1"></i> {{ totalGeral }}
            </span>
            <button class="btn btn-primary ms-2" (click)="aplicarFiltro()">
              <i class="fas fa-sync-alt me-1"></i> Recarregar
            </button>
          </div>
        </div>
      </div>

      <!-- Painel de filtros avançados -->
      <div class="row mt-2" *ngIf="showFiltros">
        <div class="col-md-3">
          <label class="form-label">Tipo Vistoria</label>
          <select class="form-select" [(ngModel)]="filtroTipoVistoria">
            <option value="">Todos</option>
            <option value="Cadastro">Cadastro</option>
            <option value="Recadastro">Recadastro</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Status</label>
          <select class="form-select" [(ngModel)]="filtroStatusOS">
            <option value="">Todos</option>
            <option value="Concluida">Concluído</option>
            <option value="Negada">Negado</option>
            <option value="Retornar">Retornar</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Bairro</label>
          <input type="text" class="form-control" [(ngModel)]="filtroBairro" placeholder="Bairro" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Cidade</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCidade" placeholder="Cidade" />
        </div>
        <div class="col-12 mt-2 d-flex gap-2">
          <button class="btn btn-primary" (click)="aplicarFiltro()">Aplicar filtros</button>
          <button class="btn btn-secondary" (click)="resetarERecarregar()">Limpar e Recarregar</button>
        </div>
      </div>
    </div>
  </div>

  <ngx-spinner bdColor="rgba(0,0,0,0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p style="color: white"> Processando, por favor aguarde... </p>
  </ngx-spinner>

  <div *ngIf="erro" class="alert alert-danger d-flex align-items-center gap-2">
    <i class="fas fa-exclamation-triangle"></i> {{ erro }}
  </div>

  <div *ngIf="!carregando && !erro && dados">

    <!-- Cards de resumo -->
    <div class="resumo-grid mb-4">
      <div class="resumo-card resumo-total">
        <div class="resumo-icon"><i class="fas fa-chart-pie"></i></div>
        <div class="resumo-info">
          <span class="resumo-label">Total Geral</span>
          <span class="resumo-valor">{{ totalGeral }}</span>
        </div>
      </div>
      <div class="resumo-card resumo-cadastro">
        <div class="resumo-icon"><i class="fas fa-user-plus"></i></div>
        <div class="resumo-info">
          <span class="resumo-label">Cadastramentos</span>
          <span class="resumo-valor">{{ totalCadastramento.total }}</span>
        </div>
      </div>
      <div class="resumo-card resumo-recadastro">
        <div class="resumo-icon"><i class="fas fa-user-edit"></i></div>
        <div class="resumo-info">
          <span class="resumo-label">Recadastramentos</span>
          <span class="resumo-valor">{{ totalRecadastramento.total }}</span>
        </div>
      </div>
    </div>

    <div class="analise-grid mb-4">
      <div class="analise-card cadastro-analise">
        <div class="analise-header">
          <i class="fas fa-user-plus me-1"></i> Analise do Cadastramento
        </div>
        <div class="analise-pills">
          <span class="status-pill badge-validado">Validado: {{ analiseCadastramento.validado }}</span>
          <span class="status-pill badge-invalido">Invalido: {{ analiseCadastramento.invalido }}</span>
          <span class="status-pill badge-pendente">Pendente: {{ analiseCadastramento.pendente }}</span>
        </div>
      </div>

      <div class="analise-card recadastro-analise">
        <div class="analise-header">
          <i class="fas fa-user-edit me-1"></i> Analise do Recadastramento
        </div>
        <div class="analise-pills">
          <span class="status-pill badge-validado">Validado: {{ analiseRecadastramento.validado }}</span>
          <span class="status-pill badge-invalido">Invalido: {{ analiseRecadastramento.invalido }}</span>
          <span class="status-pill badge-pendente">Pendente: {{ analiseRecadastramento.pendente }}</span>
        </div>
      </div>
    </div>

    <!-- SEÇÃO CADASTRAMENTO -->
    <div class="secao-card mb-4">
      <div class="secao-header cadastro-header">
        <div class="d-flex align-items-center gap-2">
          <i class="fas fa-user-plus"></i>
          <span>Cadastramento</span>
          <span class="total-badge">{{ totalCadastramento.total }}</span>
        </div>
        <div class="status-pills">
          <span
            *ngFor="let status of totalCadastramento.porStatus"
            class="status-pill"
            [ngClass]="getStatusColor(status.status)">
            {{ formatarStatus(status.status) }}: {{ status.total }}
          </span>
        </div>
      </div>
      <div class="table-responsive" *ngIf="cadastramento.length > 0">
        <table class="table table-bordered table-hover align-middle">
          <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Cidade</th>
              <th>Bairro</th>
              <th>Total Vistorias</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of cadastramento; let i = index"
                [class]="i % 2 === 0 ? 'linha-par' : 'linha-impar'">
              <td>{{ i + 1 }}</td>
              <td class="text-start fw-semibold">{{ item.cidade || '-' }}</td>
              <td>{{ item.bairro || '-' }}</td>
              <td><span class="total-vistoria-badge cadastro-badge">{{ item.totalVistorias }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="cadastramento.length === 0" class="alert alert-warning m-3">
        Nenhum dado de cadastramento encontrado.
      </div>
    </div>

    <!-- SEÇÃO RECADASTRAMENTO -->
    <div class="secao-card mb-4">
      <div class="secao-header recadastro-header">
        <div class="d-flex align-items-center gap-2">
          <i class="fas fa-user-edit"></i>
          <span>Recadastramento</span>
          <span class="total-badge">{{ totalRecadastramento.total }}</span>
        </div>
        <div class="status-pills">
          <span
            *ngFor="let status of totalRecadastramento.porStatus"
            class="status-pill"
            [ngClass]="getStatusColor(status.status)">
            {{ formatarStatus(status.status) }}: {{ status.total }}
          </span>
        </div>
      </div>
      <div class="table-responsive" *ngIf="recadastramento.length > 0">
        <table class="table table-bordered table-hover align-middle">
          <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Cidade</th>
              <th>Bairro</th>
              <th>Total Vistorias</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of recadastramento; let i = index"
                [class]="i % 2 === 0 ? 'linha-par' : 'linha-impar'">
              <td>{{ i + 1 }}</td>
              <td class="text-start fw-semibold">{{ item.cidade || '-' }}</td>
              <td>{{ item.bairro || '-' }}</td>
              <td><span class="total-vistoria-badge recadastro-badge">{{ item.totalVistorias }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="recadastramento.length === 0" class="alert alert-warning m-3">
        Nenhum dado de recadastramento encontrado.
      </div>
    </div>

  </div>

  <div *ngIf="!carregando && !erro && !dados" class="alert alert-warning d-flex align-items-center gap-2">
    <i class="fas fa-folder-open"></i>
    Nenhum dado encontrado para o período selecionado.
  </div>

</div>
